import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ActiveCustomer } from '../models/active-customer';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  constructor(private http: HttpClient) {}

  getCustomers(objectId: string, tenantId: string): Observable<ActiveCustomer[]> {
    const params = new HttpParams()
      .set('objectId', objectId)
      .set('tenantId', tenantId)
      .set('code', environment.apiKey);

    return this.http.get<any[]>(environment.apiUrl + 'GetCustomers', { params }).pipe(
      // Backend response casing can vary (camelCase vs PascalCase); normalize defensively.
      map((list) =>
        (list ?? []).map((c) => ({
          CustomerId: c.CustomerId ?? c.customerId ?? '',
          CustomerName: c.CustomerName ?? c.customerName ?? '',
          TenantId: c.TenantId ?? c.tenantId ?? '',
        }))
      )
    );
  }
}
